import { Image, Modal } from 'antd';
import React from 'react'
import { StaticImages } from '../Utils/StaticImages';
import CustomButton from '../Components/CustomButton';

const DeleteModal = (
    { openDeleteModal,
        closable = false, footer = false,
        width = "350",
        centered = true, title1 = "Delete User",
        title2 = "Are you sure you want to Delete this User?",
        DeleteButton = "Yes", CancelButton = "Cancel",
        setOpenDeleteModal,
        selectedUser,
        selectedQuestion,
        handleDeleteFAQ,
        onDelete,
        

    }
) => {


    const handleDelete = async () => {
        if (onDelete) {
            await onDelete(); // Call the delete function passed from the parent
        }
        if (handleDeleteFAQ) {
            await handleDeleteFAQ(); // Call the delete handler passed from FAQ
        }

        setOpenDeleteModal(false);
    };
    const handleQuestion = () => {
        console.log('Question Deleted:', selectedQuestion);
        setOpenDeleteModal(false);
    }

    return (
        <>
            {openDeleteModal && (
                <Modal
                    open={openDeleteModal}
                    onCancel={() => setOpenDeleteModal(false)}
                    closable={closable}
                    footer={footer}
                    centered={centered}
                >
                    <div
                        className="flex justify-center items-center flex-col gap-[14px]"
                    >
                        <Image src={StaticImages.DeleteBin.Icon} alt='Deletedimage' preview={false}
                            draggable={false} className="mt-8" />
                        <p className="text-h2 font-bold">{title1}</p>
                        <p>{title2}</p>

                        {/**buttons */}
                        {/**delete button  */}
                        <div className="flex gap-[10px] mb-8">

                            <CustomButton
                                onClick={() => {
                                    handleDelete();
                                    handleQuestion();
                                }}

                                title={DeleteButton}
                                className='bg-green-600 rounded-full text-white-100 w-[7rem]  sm:w-[10rem]  !important'
                            />
                            <CustomButton
                                onClick={() => {
                                    setOpenDeleteModal(false);
                                    console.log("cancel");
                                }}
                                title={CancelButton}
                                className='bg-red-200 rounded-full text-white-100 w-[7rem]  sm:w-[10rem] !important'
                            />
                        </div>
                    </div>
                </Modal>
            )}
        </>
    )
}

export default DeleteModal